import router from './router';
import store from './store';
import Config from '@/utils/config';
import Cache from '@/utils/cache';
// import { Message } from 'element-ui';
import { isLogined } from '@/utils/fnc';

// 设置白名单
const whiteList = ['/login'];
// 路由拦截
router.beforeEach((to, from, next) => {
  const staffId = Cache.get(Config.STAFFID);

  if (isLogined()) {
    if (!store.state.app.staffId) {
      const userInfo = Cache.get(Config.USERINFO);
      store.dispatch('app/updateUserInfo', userInfo);
      store.dispatch('app/updateStaffId', staffId);
    }

    if (to.path === '/login' || to.redirectedFrom === '/') {
      staffId
        ? next({ path: '/dashboardManagement/groupList' })
        : next({ path: '/organization' });
      return;
    }

    if (to.path === '/organization') {
      staffId ? next({ path: '/dashboardManagement/groupList' }) : next();
      return;
    }

    next();
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      // 否则全部重定向到登录页
      next('/login');
    }
  }
});
